// Pricing terminology helper (v79.93).
//
// Founder rule: physical retail products carry an "MRP" (Maximum Retail
// Price), while services / software / digital offerings quote a
// "List Price / MSRP". We show the MRP field as a strike-through anchor
// so buyers can see the discount they're getting versus the seller's
// asking price.
//
// Categories where the MRP field is HIDDEN entirely (no meaningful list
// price): jobs, resumes, matrimony profiles, real estate.

const SERVICE_LIKE_CATEGORIES = new Set([
    "it",
    "services",
    "hospitals",
    "education",
    "event-management",
    "function-halls",
    "beauty-parlours",
    "iron-shop",
    "vehicle-rental",
    "home-maid",
    "mutual-fund-distributor",
    "insurance-distributor",
    "mutual-fund",
    "insurance",
    "financial-services",
    "travel",
    "health-wellness",
    "beauty-personal-care",
]);

const NO_MRP_CATEGORIES = new Set([
    "jobs",
    "job-seeker",
    "matrimony",
    "real-estate",
    // v79.181 — Item 22: Movies/OTT/Webseries is announcement-only,
    // never has a price/MRP.
    "movies-ott",
    // v79.187 — Founder direction (production, Feb 2026): insurance +
    // mutual-fund policies are quoted-on-request, never carry a
    // headline price/MRP on the tile.
    "insurance",
    "mutual-fund",
    "insurance-distributor",
    "mutual-fund-distributor",
]);

export function showMrpField(category) {
    if (!category) return true;
    return !NO_MRP_CATEGORIES.has(category);
}

export function mrpLabel(category) {
    if (SERVICE_LIKE_CATEGORIES.has(category)) return "List Price / MSRP";
    return "MRP";
}

export function mrpShortLabel(category) {
    if (SERVICE_LIKE_CATEGORIES.has(category)) return "List";
    return "MRP";
}

/** Percent discount (rounded down) when MRP is strictly greater than the
 *  asking price, otherwise 0. Safe against non-numeric inputs. */
export function discountPercent(mrp, price) {
    const m = Number(mrp);
    const p = Number(price);
    if (!isFinite(m) || !isFinite(p)) return 0;
    if (m <= 0 || p < 0 || m <= p) return 0;
    return Math.floor(((m - p) / m) * 100);
}

// v79.94 — Categories where public star-ratings + comment threads do
// NOT make sense. People-oriented listings (job postings, candidate
// profiles, matrimony) MUST NOT carry public ratings — that would be a
// dignity / privacy failure. Everything else (physical products,
// services, software, real estate, digital stores) can be rated.
const NO_REVIEW_CATEGORIES = new Set([
    "jobs",
    "job-seeker",
    "matrimony",
    // v79.181 — Movies/OTT posts are announcements; ratings don't apply.
    "movies-ott",
]);

/** True when the listing category supports ratings + comments. */
export function canReview(category) {
    if (!category) return false;
    return !NO_REVIEW_CATEGORIES.has(category);
}
